import(/* webpackMode: "eager" */ "/vercel/path0/src/app/khoa-hoc/page.tsx");
